<template>
  <div>
    <div class="page_title flex_between">
      <span>新增专科门诊</span>
      <el-button style="width: 100px" @click="back" type="primary"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="专科门诊名称" prop="sd_name">
            <el-input
              v-model="ruleForm.sd_name"
              maxlength="15"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="专科门诊说明" style="margin-bottom: 80px">
            <el-input
              v-model="ruleForm.sd_desc"
              :rows="4"
              maxlength="300"
              style="width: 500px"
              type="textarea"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            label="展示图片"
            prop="sd_image"
            style="margin-bottom: 200px"
          >
            <div class="imgbox">
              <el-upload
                class="avatar-uploader"
                name="image"
                accept=".png,.jpeg,.jpg"
                :action="uploadUrl"
                :data="uploadExtraData"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="ruleForm.sd_image"
                  :src="ruleForm.sd_image_str"
                  class="avatar"
                />
                <div v-else>
                  <i class="el-icon-circle-plus uploader-icon"></i>
                  <div style="color: #8c99a4; font-weight: 600">请上传图片</div>
                  <div style="width: 130px; color: #a9b4b6; font-size: 12px">
                    支持jpg, png, jpeg格式
                  </div>
                </div>
              </el-upload>
              <div
                class="big_btn"
                v-if="ruleForm.sd_image"
                @click="zoomIn = true"
              >
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
            <div style="color: #999; text-align: center; width: 250px">
              建议尺寸750x600
            </div>
          </el-form-item>
          <div class="flex">
            <div class="title_class">专科门诊引导语</div>
            <div style="margin-bottom: 20px">
              <div>
                <el-button
                  type="primary"
                  size="medium"
                  style="width: 80px"
                  @click="addTitle"
                  >添加</el-button
                >
              </div>
              <div
                v-for="(item, index) in ruleForm.title"
                :key="index"
                style="margin-top: 10px"
                class="align-center"
              >
                <el-input
                  v-model="item.title"
                  :rows="2"
                  maxlength="300"
                  style="width: 700px; margin-right: 10px"
                  type="textarea"
                  show-word-limit
                ></el-input>
                <div>
                  <el-button
                    type="text"
                    v-if="index != 0"
                    @click="updateSort(index, 1)"
                    >上移</el-button
                  >
                  <el-button
                    type="text"
                    v-if="index != ruleForm.title.length - 1"
                    @click="updateSort(index, 2)"
                    >下移</el-button
                  >
                  <el-button type="text" @click="updateSort(index, 3)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="title_class">专科门诊推荐关键词</div>
            <div>
              <div style="color: #fa5a2f">
                选择关键词时请选择与当前专科有关的关键词
              </div>
              <div class="key_box">
                <div class="key_left">
                  <div>
                    <el-input
                      size="medium"
                      placeholder="关键词"
                      suffix-icon="el-icon-search"
                      v-model="keywords_name"
                      style="width: 300px"
                      @change="getKeywordsData"
                    />
                  </div>
                  <div class="key_list">
                    <div
                      v-for="(item, index) in keyList"
                      :key="index"
                      class="key_name"
                      @click="AddKeyword(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
                <div class="key_right">
                  <transition-group tag="div" class="transition">
                    <div
                      class="drag_item"
                      v-for="(item, i) in keywords_name_list"
                      :key="i"
                      draggable="true"
                      @dragstart="handleDragStart($event, item)"
                      @dragover.prevent="handleDragOver($event, item)"
                      @dragenter="handleDragEnter($event, item)"
                      @dragend="handleDragEnd($event, item)"
                    >
                      {{ item }}
                      <el-button
                        type="text"
                        icon="el-icon-delete"
                        @click="delKeyword(i)"
                      ></el-button>
                    </div>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <div style="padding-left: 400px; margin-top: 30px">
          <el-button
            style="width: 120px"
            @click="submit('ruleForm')"
            type="primary"
            >保存</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="查看图片"
      :visible.sync="zoomIn"
    >
    <div style="padding:20px">
      <img :src="ruleForm.sd_image_str" alt="" style="width: 600px" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import constant from "../../../service/common/constant";

export default {
  data() {
    return {
      sd_id: "",
      uploadExtraData: {
        img_type: 4,
        suffix: ".jpg",
      },
      ruleForm: {
        sd_name: "",
        sd_desc: "",
        keywords_name: "",
        sd_image: "",
        sd_image_str: "",
        title: [],
      },
      rules: {
        sd_name: [
          {
            required: true,
            message: "请输入专科门诊名称",
            trigger: "blur",
          },
        ],
        sd_image: [
          { required: true, message: "请上传展示图片", trigger: "blur" },
        ],
      },
      keywords_name: "",
      keyList: [],
      dragging: null,
      keywords_name_list: [],
      zoomIn: false,
    };
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "api/platform/upload/uploadFile";
      } else {
        return "platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  methods: {
    //获取平台关键字
    getKeywordsData() {
      let keywords_name = this.keywords_name;
      this.axios
        .post("platform/guidance/getKeywordsData", { keywords_name })
        .then((res) => {
          if (res.code == 0) {
            this.keyList = res.data.list;
          }
        });
    },
    //获取详情
    getDetail() {
      let sd_id = this.sd_id;
      this.axios
        .post("platform/guidance/getSpecialtyDepartmentInfo", { sd_id })
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = res.data;
            this.keywords_name_list = res.data.keywords_name
              ? res.data.keywords_name.split(",")
              : [];
          }
        });
    },
    //上传成功
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        //半路径
        this.ruleForm.sd_image = res.data.pic;
        //绝对路径
        this.ruleForm.sd_image_str = res.data.path;
      }
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg 格式!");
        return false;
      }
      if (!isLt15M) {
        this.$message.error("上传图片大小不能超过15MB!");
        return false;
      }
      return isSupportType && isLt15M;
    },
    //拖动
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.keywords_name_list];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.keywords_name_list = newItems;
    },
    //添加引导语
    addTitle() {
      if (this.ruleForm.title.length == 5) {
        this.$message.error("最多可设置5条引导语");
        return false;
      }
      if (this.ruleForm.title.length) {
        let a = 1;
        this.ruleForm.title.forEach((item) => {
          if (!item.title) {
            a = 0;
            return;
          }
        });
        if (a) {
          let data = { title: "" };
          this.ruleForm.title.push(data);
        }
      } else {
        let data = { title: "" };
        this.ruleForm.title.push(data);
      }
    },
    //排序 删除
    updateSort(index, status) {
      let data = this.ruleForm.title[index];
      this.ruleForm.title.splice(index, 1);
      //上移
      if (status == 1) {
        this.ruleForm.title.splice(index - 1, 0, data);
      }
      //下移
      if (status == 2) {
        this.ruleForm.title.splice(index + 1, 0, data);
      }
    },
    //添加关键词
    AddKeyword(item) {
      if (this.keywords_name_list.length == 10) {
        this.$message.error("最多选择10个关键词");
        return false;
      }
      let a = 1;
      this.keywords_name_list.forEach((i) => {
        if (item == i) {
          a = 0;
          this.$message.error(item + "已经被选择");
          return;
        }
      });
      if (a) {
        this.keywords_name_list.push(item);
      }
    },
    //删除关键词
    delKeyword(i) {
      this.keywords_name_list.splice(i, 1);
    },
    //提交
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          data.keywords_name = this.keywords_name_list.toString();
          let url = "platform/guidance/addSpecialtyDepartment";
          if (this.sd_id) {
            url = "platform/guidance/updateSpecialtyDepartment";
          }
          this.axios.post(url, data).then((res) => {
            if (res.code == 0) {
              this.$message.success("保存成功");
              this.back();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getKeywordsData();
    if (this.$route.query.sd_id) {
      this.sd_id = this.$route.query.sd_id;
      this.getDetail();
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.imgbox {
  width: 250px;
  height: 200px;
  background-color: #eff3f5;
  box-shadow: inset 2px 2px 4px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: dashed 1px #b8c4ce;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  .avatar {
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  .uploader-icon {
    font-size: 60px;
    color: #36af71;
  }
  .big_btn {
    display: none;
    bottom: 0px;
    width: 100%;
    text-align: center;
    position: absolute;
    background: #dedede;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
  }
  &:hover .big_btn {
    display: block;
  }
}

.title_class {
  width: 140px;
  text-align: right;
  color: #707070;
  padding-right: 12px;
  box-sizing: border-box;
}
.key_box {
  width: 700px;
  border: 1px solid #dcdfe6;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
  .key_left {
    width: 340px;
    border: 1px solid #dcdfe6;
    height: 400px;
    padding: 20px;
    box-sizing: border-box;
    .key_list {
      background: #f5f5f5;
      margin-top: 20px;
      height: 300px;
      overflow-y: scroll;
      box-sizing: border-box;
      border: 1px solid #dcdfe6;
    }
    .key_name {
      padding: 0 20px;
      line-height: 40px;
      font-size: 15px;
      cursor: pointer;
    }
    .key_name:nth-child(2n-1) {
      background: #fff;
    }
  }
  .key_right {
    width: 300px;
    .transition {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .drag_item {
      width: 45%;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-bottom: 20px;
    }
  }
}
</style>
